"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ramda = require("ramda");

var _propTypes = require("prop-types");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _filtersAccordion = _interopRequireDefault(require("./filters-accordion"));

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var defaultTitleFont = {
  color: "text-light-grey",
  fontSize: [1, 1, 0],
  fontWeight: 500,
  letterSpacing: ["1.8px", "1.8px", "1.5px"],
  lineHeight: [1, 1, 2]
};
var propTypes = {
  /** Object map of filters currently active */
  activeFilters: (0, _propTypes.objectOf)(_propTypes.bool),
  // Object map of filters currently disabled
  disabledFilters: (0, _propTypes.objectOf)(_propTypes.bool),

  /** Array to be rendered as checkboxes */
  filterGroups: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    /** ID of each filter group, used for key prop */
    id: _propTypes.string.isRequired
  })).isRequired,

  /** onChange event handler - used to process the filter selection event */
  filterOnChange: _propTypes.func,
  // Total Filter to show
  maxFiltersToShow: _propTypes.number,
  // Callback to handle more button click event
  showMoreOnClick: _propTypes.func,

  /** Title of filters group */
  title: _propTypes.string,

  /** Font styles for filters group title */
  titleFont: _utils.fontPropType
};
var defaultProps = {
  maxFiltersToShow: 5,
  showMoreOnClick: _ramda.identity,
  title: "FILTER BY",
  titleFont: defaultTitleFont
};

var FiltersComponent = function FiltersComponent(_ref) {
  var activeFilters = _ref.activeFilters,
      disabledFilters = _ref.disabledFilters,
      _ref$filterGroups = _ref.filterGroups,
      filterGroups = _ref$filterGroups === void 0 ? [] : _ref$filterGroups,
      filterOnChange = _ref.filterOnChange,
      maxFiltersToShow = _ref.maxFiltersToShow,
      showMoreOnClick = _ref.showMoreOnClick,
      title = _ref.title,
      titleFont = _ref.titleFont;
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    flexWrap: "wrap",
    my: 2,
    width: 1
  }, title ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    borderBottom: ["solid 1px", "solid 1px", "none"],
    borderBottomColor: ["gray-divider", "gray-divider"],
    width: 1
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, _extends({
    color: "text-helper",
    px: [3, 3, 0],
    py: [2, 2, 1],
    tag: "legend"
  }, titleFont), title)) : null, (0, _ramda.map)(function (_ref2) {
    var filters = _ref2.filters,
        id = _ref2.id,
        label = _ref2.label;
    return /*#__PURE__*/_react["default"].createElement(_filtersAccordion["default"], {
      key: id,
      activeFilters: activeFilters,
      disabledFilters: disabledFilters,
      filterOnChange: filterOnChange,
      filters: filters,
      label: label,
      maxFiltersToShow: maxFiltersToShow,
      moreButtonOnClick: showMoreOnClick
    });
  }, filterGroups));
};

FiltersComponent.propTypes = propTypes;
FiltersComponent.defaultProps = defaultProps;
FiltersComponent.displayName = "Modules.FiltersComponent";
var _default = FiltersComponent;
exports["default"] = _default;